import { SCOPE_CHIP_SX, TOKENS } from '../../../theme/muiTheme';

import { CLIMATE_ACTION_COLORS } from './climateActionColors';



const LOCATION_KEY_BY_LABEL = Object.freeze({

  'Landmark Office': 'landmarkOffice',

  'All offices': 'allOffices',

  'Tokyo fleet': 'tokyoFleet',

  'Osaka Office': 'osakaOffice',

  'Company-wide shipping': 'companyWideShipping',

  'Mita Office': 'mitaOffice',

  Japan: 'japan',

});



export const localizedClimateLocation = (location, t) => {

  const locationKey = LOCATION_KEY_BY_LABEL[location];

  return locationKey ? t(`climateAction.locations.${locationKey}`) : location;

};



export const scopeChipSx = (scope) => {

  const normalized = String(scope || '').replace(/\s+/g, '').toLowerCase();

  if (normalized === 'scope1') return SCOPE_CHIP_SX.SCOPE_1;

  if (normalized === 'scope2') return SCOPE_CHIP_SX.SCOPE_2;

  if (normalized.startsWith('scope3')) return SCOPE_CHIP_SX.SCOPE_3;

  if (normalized === 'retiredoffset' || normalized === 'retiredcarboncredit') return { bgcolor: TOKENS.successBg, color: TOKENS.success, fontWeight: 700 };

  if (normalized === 'mappingpending') return { bgcolor: TOKENS.warningBg, color: TOKENS.warningText, fontWeight: 700 };

  return { bgcolor: CLIMATE_ACTION_COLORS.otherBackground, color: CLIMATE_ACTION_COLORS.other, fontWeight: 700 };

};



export const readinessChipColor = (readiness) => {

  if (readiness === 'verified' || readiness === 'ready') return 'success';

  if (readiness === 'needsData' || readiness === 'needsEvidence') return 'warning';

  return 'default';

};



export const statusChipColor = (status) => {

  const normalized = String(status || '').replace(/[_\s-]/g, '').toLowerCase();

  if (normalized === 'completed' || normalized === 'verified') return 'success';

  if (['inprogress', 'approved', 'reported'].includes(normalized)) return 'info';

  if (normalized === 'rejected' || normalized === 'notapproved') return 'error';

  if (['evidencepending', 'pendingreview', 'underreview'].includes(normalized)) return 'warning';

  return 'default';

};



export const RECOMMENDATION_FINANCE_AVAILABILITY = Object.freeze({

  AVAILABLE: 'AVAILABLE',

  COST_BASIS_REQUIRED: 'COST_BASIS_REQUIRED',

  COST_DATA_REQUIRED: 'COST_DATA_REQUIRED',

  NOT_APPLICABLE: 'NOT_APPLICABLE',

});



/** Accept only the backend-owned numeric scenario; never derive a percentage from LLM prose. */

export function recommendationTargetGapCoverage(recommendation = {}) {

  const value = recommendation.targetGapCoveragePercent

    ?? recommendation.target_gap_coverage_percent

    ?? null;

  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;

}



const FINANCE_VALUE_BLOCKING_STATUSES = new Set([

  'NEEDS_DATA', 'NEEDS_APPROVED_RATE', 'NEEDS_APPROVED_PRICE',

  'RATE_REQUIRED', 'NOT_APPLICABLE',

]);



const APPROVED_RATE_REQUIRED_STATUSES = new Set([

  'NEEDS_APPROVED_RATE', 'NEEDS_APPROVED_PRICE', 'RATE_REQUIRED',

]);



const finiteNumberOrNull = (value) => {

  if (value === null || value === undefined || String(value).trim() === '') return null;

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;

};



/**

 * Normalize the recommendation's financial display once for both card and drawer.

 * A blocking backend status always wins over a stale numeric compatibility field.

 */

export function recommendationFinancialPresentation(finance = {}) {

  const status = String(finance.status || '').toUpperCase();

  const blocked = FINANCE_VALUE_BLOCKING_STATUSES.has(status);

  const savings = blocked ? null : finiteNumberOrNull(

    finance.estimatedAnnualSavingsJpy ?? finance.annualSavingsJpy,

  );

  const cost = blocked ? null : finiteNumberOrNull(

    finance.estimatedAnnualCostJpy ?? finance.annualCostJpy,

  );

  const fallback = blocked ? null : finiteNumberOrNull(finance.estimatedJpyImpact);

  const value = savings ?? cost ?? fallback;

  let availability = RECOMMENDATION_FINANCE_AVAILABILITY.AVAILABLE;

  if (status === 'NOT_APPLICABLE') {

    availability = RECOMMENDATION_FINANCE_AVAILABILITY.NOT_APPLICABLE;

  } else if (APPROVED_RATE_REQUIRED_STATUSES.has(status)) {

    availability = RECOMMENDATION_FINANCE_AVAILABILITY.COST_BASIS_REQUIRED;

  } else if (value === null) {

    availability = RECOMMENDATION_FINANCE_AVAILABILITY.COST_DATA_REQUIRED;

  }

  return {

    availability,

    kind: savings !== null ? 'SAVING' : 'COST',

    source: finance.costSource || null,

    value,

  };

}